import { useState, useEffect } from 'react';

import PropTypes from 'prop-types';

import {
  Card,
  CardContent,
  LinearProgress,
  Typography,
  IconButton,
  Divider,
  Box,
} from '@mui/material';

import Iconify from '@/components/iconify';
import ConditionSkeleton from '@/components/skeleton/ConditionSkeleton';

import { fPercent } from '@/utils/formatNumber';

DetailsCard.propTypes = {
  data: PropTypes.array,
  fetching: PropTypes.bool,
};

function DetailsCard({ data, fetching }) {
  const [showValues, setShowValues] = useState([]);

  useEffect(() => {
    if (!fetching && data?.length) {
      setShowValues(data.map(() => true));
    }
  }, [fetching, data]);


  useEffect(() => {
    if (data?.length) {
      setShowValues(data.map(() => true));
    }
  }, [data]);

  const toggleShowValue = (index) => {
    setShowValues((prev) => prev.map((showValue, i) => (i === index ? !showValue : showValue)));
  };

  return (
    <>
      {fetching ? (
        <LinearProgress sx={{ position: 'absolute', top: 0, left: 0, width: '100%' }} />
      ) : (
        <Card
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <CardContent sx={{ flexGrow: 1 }}>
            {data.map((item, index) => (
              <Box key={index}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Box>
                    <Typography variant="body2">{item.title}</Typography>
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      sx={{ filter: showValues[index] ? 'none' : 'blur(12px)' }}
                    >
                      {item.isNumeral ? +item.value : fPercent(item.value)}
                    </Typography>
                  </Box>
                  <ConditionSkeleton loading={fetching}>
                    <IconButton onClick={() => toggleShowValue(index)} edge="end">
                      <Iconify
                        width={30}
                        icon={showValues[index] ? 'eva:eye-fill' : 'eva:eye-off-fill'}
                      />
                    </IconButton>
                  </ConditionSkeleton>
                </Box>
                {index < data.length - 1 && (
                  <Divider sx={{ backgroundColor: '#4A5568', marginY: 1 }} />
                )}
              </Box>
            ))}
          </CardContent>
        </Card>
      )}
    </>
  );
}

export default DetailsCard;
